import React from "react";
import "./contactUs.css";

const ContactForm = () => {
  return (
    <div className="form-wrapper">
      <div className="row">
        <div className="col-12">
          <div className="form-container">
            <div className="input-container">
              <div className="row">
                <div className="col-12 col-sm-6">
                  <label htmlFor="fullName">
                    Full Name<strong className="text-danger">&nbsp;*</strong>
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    className="form-control"
                    placeholder="Robert Parker"
                  />
                </div>
                <div className="col-12 col-sm-6">
                  <label htmlFor="workEmail">
                    Work Email<strong className="text-danger">&nbsp;*</strong>
                  </label>
                  <input
                    type="text"
                    id="workEmail"
                    className="form-control"
                    placeholder="example@gmail.com"
                  />
                </div>
                <div className="col-12 col-sm-6">
                  <label htmlFor="companyName">
                    Company Name
                    <strong className="text-danger">&nbsp;*</strong>
                  </label>
                  <input
                    type="text"
                    id="companyName"
                    className="form-control"
                    placeholder="Soori Corporation"
                  />
                </div>
                <div className="col-12 col-sm-6">
                  <label htmlFor="phone">Phone Number (Optional)</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="9***********"
                  />
                </div>
                <div className="col-12">
                  <label htmlFor="message">
                    How Can We Fuel Your Success?
                    <strong className="text-danger">&nbsp;*</strong>
                  </label>
                  <textarea
                    rows={5}
                    id="message"
                    placeholder="Write your message..."
                  />
                </div>
                <div className="col-12">
                  <button className="btn">Contact Us</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
